(function () {
  function parseBool(value) {
    return value === true || value === "true";
  }

  function getVideos(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(".modular-framed-video__video")
    );
  }

  function getActiveVideo(root, videos) {
    var mobile = root.querySelector(".modular-framed-video__video--mobile");
    var desktop = root.querySelector(".modular-framed-video__video--desktop");

    if (mobile && desktop) {
      return window.matchMedia("(min-width: 768px)").matches ? desktop : mobile;
    }

    return videos[0] || null;
  }

  function init(root) {
    if (!root || root.getAttribute("data-mfv-initialized") === "true") return;

    var videos = getVideos(root);
    if (!videos.length) return;

    root.setAttribute("data-mfv-initialized", "true");

    var playPauseBtn = root.querySelector("[data-mfv-playpause]");
    var soundBtn = root.querySelector("[data-mfv-sound]");
    var showPlay = parseBool(root.getAttribute("data-show-playpause"));
    var showSound = parseBool(root.getAttribute("data-show-sound"));
    var autoplay = parseBool(root.getAttribute("data-autoplay"));
    var desktopMq = window.matchMedia("(min-width: 768px)");
    var hasSplitVideos = videos.length > 1;

    var iconPlay = playPauseBtn && playPauseBtn.querySelector("[data-mfv-icon-play]");
    var iconPause = playPauseBtn && playPauseBtn.querySelector("[data-mfv-icon-pause]");
    var iconSoundOn = soundBtn && soundBtn.querySelector("[data-mfv-icon-sound-on]");
    var iconSoundOff = soundBtn && soundBtn.querySelector("[data-mfv-icon-sound-off]");

    var playbackState = {
      paused: !autoplay,
      muted: autoplay,
    };

    function activeVideo() {
      return getActiveVideo(root, videos);
    }

    function syncPlayPauseUi() {
      if (!playPauseBtn) return;
      var paused = playbackState.paused;
      if (iconPlay) iconPlay.toggleAttribute("hidden", !paused);
      if (iconPause) iconPause.toggleAttribute("hidden", paused);
      playPauseBtn.setAttribute("aria-label", paused ? "Play video" : "Pause video");
    }

    function syncSoundUi() {
      if (!soundBtn) return;
      var muted = playbackState.muted;
      if (iconSoundOn) iconSoundOn.toggleAttribute("hidden", muted);
      if (iconSoundOff) iconSoundOff.toggleAttribute("hidden", !muted);
      soundBtn.setAttribute("aria-label", muted ? "Unmute video" : "Mute video");
    }

    function applyMutedToAll() {
      videos.forEach(function (video) {
        video.muted = playbackState.muted;
        if (playbackState.muted) {
          video.setAttribute("muted", "");
        } else {
          video.removeAttribute("muted");
        }
      });
    }

    function setMuted(muted) {
      playbackState.muted = muted;
      applyMutedToAll();
      syncSoundUi();
    }

    function pauseAll() {
      playbackState.paused = true;
      videos.forEach(function (video) {
        video.pause();
      });
      syncPlayPauseUi();
    }

    function playActive() {
      playbackState.paused = false;
      var active = activeVideo();
      if (!active) return;
      active.play().catch(function () {});
      syncPlayPauseUi();
    }

    function applyPlaybackState() {
      applyMutedToAll();

      var active = activeVideo();
      if (!active) return;

      videos.forEach(function (video) {
        if (video !== active) {
          video.pause();
        }
      });

      if (playbackState.paused) {
        active.pause();
      } else {
        active.play().catch(function () {});
      }

      syncPlayPauseUi();
      syncSoundUi();
    }

    function syncViewportPlayback() {
      if (!hasSplitVideos) return;
      applyPlaybackState();
    }

    if (playPauseBtn && showPlay) {
      playPauseBtn.addEventListener("click", function () {
        if (playbackState.paused) {
          playActive();
        } else {
          pauseAll();
        }
      });
    }

    if (soundBtn && showSound) {
      soundBtn.addEventListener("click", function () {
        setMuted(!playbackState.muted);
      });
    }

    videos.forEach(function (video) {
      video.addEventListener("play", function () {
        if (video === activeVideo()) {
          playbackState.paused = false;
        }
        syncPlayPauseUi();
      });

      video.addEventListener("pause", function () {
        if (video === activeVideo()) {
          playbackState.paused = true;
        }
        syncPlayPauseUi();
      });

      video.addEventListener("volumechange", function () {
        if (video === activeVideo()) {
          playbackState.muted = video.muted;
          applyMutedToAll();
        }
        syncSoundUi();
      });
    });

    if (hasSplitVideos) {
      if (typeof desktopMq.addEventListener === "function") {
        desktopMq.addEventListener("change", syncViewportPlayback);
      } else if (typeof desktopMq.addListener === "function") {
        desktopMq.addListener(syncViewportPlayback);
      }
    }

    applyPlaybackState();
  }

  function scan(container) {
    var scope = container || document;
    scope.querySelectorAll("[data-modular-framed-video]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event && event.target) scan(event.target);
  });
})();
